/* src/app/views/display/components/modals/edit-specific-date-time-modal/recurring-details-form/recurring-details-form.component.scss */
.recurring-details-header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
/*# sourceMappingURL=recurring-details-form.component.css.map */
